module.exports = __webpack_public_path__ + "q9nabuuiuvq-scott-webb.20ce342a394c2c3d5a56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding/600x600/q9nabuuiuvq-scott-webb.jpg
// module id = ./src/assets/images/wedding/600x600/q9nabuuiuvq-scott-webb.jpg
// module chunks = main